import angular from 'angular';
import uirouter from '@uirouter/angularjs';
import angulartics from 'angulartics';
import googleanalytics from 'angulartics-google-analytics';
// import angularuiscrollpoint from 'angular-ui-scrollpoint';
import angularuibootstrap from 'angular-ui-bootstrap/';
import uiSelect from 'ui-select';
// import ngSessionStorage from 'angular-sessionstorage';
import LocalStorageModule from 'angular-local-storage';
import ngSanitize from 'angular-sanitize';
import ngAnimate from 'angular-animate';
import uiMask from 'angular-ui-mask';

// things everyone depends on that need to come first
import './start.scss'; // do this first - node_module css files should be loaded first (could it go somewhere else?)
// import '../../node_modules/bootstrap-sass/assets/stylesheets/_bootstrap.scss';
// import '../../node_modules/hopscotch/dist/css/hopscotch.min.css';
import './common/styles/buttons.scss';
import './common/styles/global.scss';
import './common/styles/hero-icons.scss';
import './common/styles/hp-overlay.scss';
import './common/styles/tabset.scss';
import './common/styles/ui-select-dropdown.scss';
import './common/httpError/httpError.scss';

import Configs from './config';

import ApplicationController from './application/applicationController';

import PermissionsService from './common/angular/permissionsService';
import RequestHandlerService from './common/userAuthorization/requestHandler.service';
import UserAuthService from './common/userAuthorization/userAuthFactory';

import TopNavService from './common/topNav/topNavFactory';
import AuthenticationService from './common/userAuthorization/authentication.service';
import AuthenticationFactory from './common/userAuthorization/authentication.factory';
import httpIntercetorService from './common/httpError/httpInterceptorFactory';
import PartnerAppsService from './common/angular/PartnerAppsFactory';
import SingleSignOnService from './common/angular/singleSignOnFactory';
import FundingRequestService from './common/fundingRequestData/fundingRequest';
import SidebarService from './common/sidebar/sidebarFactory';
import UserDataService from './common/angular/UserDataFactory';
import CoachmarkService from './common/coachmark/coachmarkFactory';
import DirectiveService from './common/services/directiveService';
import DesktopProgressDirecttive from './common/progressIndicator/hpProgressIndicator';
import HPLoggerService from './common/logging/loggerService';

import MainController from './MainController';
import SidebarController from './common/sidebar/sidebarController';
import TopNavController from './common/topNav/TopNavController';
import SSOController from './common/topNav/ssoController';
import ContactInfoController from './common/topNav/contactInfoController';
import StartProjectController from './dashboard/startProjectController';


import RouteConfig from './config/app.routes';
import HttpConfig from './config/app.http.config';
import LoggingInjectorConfig from './config/app.logging.config';


// constants
import Constants from './config/constants/';
import * as HPConfig from './config/app.config';
import * as HPRoles from './config/app.roles.config';
import * as HPGeoStates from './config/app.geoStates.config';
import * as HPDisplayRules from './config/app.displayRules.config';
import * as HPTopNavRules from './config/app.topNavRules.config';
import * as HPSidebarRules from './config/app.sidebarRules.config';
import * as HPDashboardRules from './config/app.dashboardRules.config';


// Import Feature modules
import Search from './search/';
import Dasboard from './dashboard/';
import PipelineSummary from './pipelineSummary/';
import Pipeline from './pipeline';
import ProductLookup from './productCenter/';
import Resources from './resources/';
import Certification from './certification/';
import Accounts from './accounts/';
import Lead from './lead';
import ActionItems from './actionItems';
import AppDetail from './appDetail';
import Modals from './modals';
import NotificationCenter from './notificationCenter';
import HISWizard from './hisWizard';

// Import Common Modules
import Spinner from './common/spinner';
import Controls from './common/controls';
import Smarty from './common/smarty';
import Job from './common/job';
import PrimaryInformation from './common/primaryInformation';
import DataFactories from './common/dataFactories';
import Footer from './common/footer';
import Hints from './common/hints';

// Import Angular Helpers
import AngularHelpers from './common/angular/';

import WindowResizeDirective from './common/windowResize/windowResizeDirective';
import FullScreenModalSuccessDirective from './common/fullScreenModalSuccess/hpFullScreenModalSuccess';
import DropdownSmallPopupDirective from './common/dropdown/dropdownSmallPopupDirective';
import SpinnerButtonDirective from './common/controls/spinnerButton/spinnerButtonDirective';
import SpinnerLinkDirective from './common/controls/spinnerLink/spinnerLinkDirective';


require('../../node_modules/ng-mask/dist/ngMask.js');
require('../../node_modules/angular-paging/dist/paging.min.js');
require('angular-moment');


// Define the HeroPro module that will be manually bootstrapped
const HEROPro = angular.module('HeroPRO', [

    angularuibootstrap,
    uirouter,
    //  angularuiscrollpoint,
    ngAnimate,
    angulartics,
    googleanalytics,
    'bw.paging',
    'ngMask',
    uiMask,
    'angularMoment',
    // ngSessionStorage,
    LocalStorageModule,
    // "document",
    uiSelect,
    ngSanitize,

    Configs,

    // Common Features
    Spinner,
    Controls,
    Smarty,
    Job,
    PrimaryInformation,
    DataFactories,
    Footer,
    Hints,

    // Features
    Search,
    Dasboard,
    PipelineSummary,
    Pipeline,
    ProductLookup,
    Resources,
    Certification,
    Accounts,
    Lead,
    ActionItems,
    AppDetail,
    Modals,
    NotificationCenter,
    HISWizard,

    // Constants
    Constants,
    // Directives
    WindowResizeDirective,

    // Misc Helpers
    AngularHelpers,
])
    // Configs
    .config(HttpConfig)
    .config(RouteConfig)
    .config(LoggingInjectorConfig)

    // Don't know why this is required for constants to do Name.Name
    .constant('HPConfig', HPConfig.default)
    .constant('HPGeoStates', HPGeoStates.default)
    .constant('HPDisplayRules', HPDisplayRules.HPDisplayRules)
    .constant('HPTopNavRules', HPTopNavRules.HPTopNavRules)
    .constant('HPSidebarRules', HPSidebarRules.HPSidebarRules)
    .constant('HPDashboardRules', HPDashboardRules.HPDashboardRules)
    .constant('HPRoles', HPRoles.default)


    // End Constants

    // Controllers
    .controller('MainController', MainController)
    .controller('ApplicationController', ApplicationController)
    .controller('TopNavController', TopNavController)
    .controller('SSOController', SSOController)
    .controller('ContactInfoController', ContactInfoController)
    .controller('SidebarController', SidebarController)
    .controller('StartProjectController', StartProjectController)

    // Services
    .service('UserData', UserDataService)
    .service('PermissionsFactory', PermissionsService)
    .service('requestHandlerService', RequestHandlerService)
    .service('UserAuthFactory', UserAuthService)

    .service('TopNavFactory', TopNavService)
    .service('authenticationService', AuthenticationService)
    .service('AuthenticationFactory', AuthenticationFactory)
    .service('HttpInterceptorFactory', httpIntercetorService)
    .service('PartnerAppsFactory', PartnerAppsService)
    .service('SingleSignOnFactory', SingleSignOnService)
    .service('FundingRequestDatastore', FundingRequestService)
    .service('SidebarFactory', SidebarService)
    .service('coachmark', CoachmarkService)
    .service('DirectiveService', DirectiveService)

    .service('hpLoggerService', HPLoggerService)

    // Directives
    .directive('fullScreenModalSuccess', FullScreenModalSuccessDirective)
    .directive('hpProgressIndicator', DesktopProgressDirecttive)
    .directive('dropdownSmallPopup', DropdownSmallPopupDirective)
    .directive('hpSpinnerButton', SpinnerButtonDirective)
    .directive('hpSpinnerLink', SpinnerLinkDirective)

    .run(($templateCache) => {
    // add html files that need to be cached
        $templateCache.put('app/application/application.html', require('./application/application.html')); // eslint-disable-line global-require
        $templateCache.put('app/common/specialNotice/specialNotice.html', require('./common/specialNotice/specialNotice.html')); // eslint-disable-line global-require
        $templateCache.put('app/common/specialNotice/shouldSignTC.html', require('./common/specialNotice/shouldSignTC.html')); // eslint-disable-line global-require
        $templateCache.put('app/common/topNav/topNav.html', require('./common/topNav/topNav.html')); // eslint-disable-line global-require
        $templateCache.put('app/common/sidebar/sidebar.html', require('./common/sidebar/sidebar.html')); // eslint-disable-line global-require
        $templateCache.put('app/common/topNav/popovers/contactInfo.html', require('./common/topNav/popovers/contactInfo.html')); // eslint-disable-line global-require
        $templateCache.put('app/common/topNav/popovers/brandSwitcher.html', require('./common/topNav/popovers/brandSwitcher.html')); // eslint-disable-line global-require
        $templateCache.put('app/common/topNav/popovers/locationSwitcher.html', require('./common/topNav/popovers/locationSwitcher.html')); // eslint-disable-line global-require
        $templateCache.put('app/common/topNav/popovers/proposalOptions.html', require('./common/topNav/popovers/proposalOptions.html')); // eslint-disable-line global-require
        $templateCache.put('app/common/topNav/popovers/userInfo.html', require('./common/topNav/popovers/userInfo.html')); // eslint-disable-line global-require
        $templateCache.put('app/common/fullScreenModalSuccess/fullScreenModalSuccess.html', require('./common/fullScreenModalSuccess/fullScreenModalSuccess.html')); // eslint-disable-line global-require

        $templateCache.put('app/common/coachmark/coachmarkDefaultTemplate.html', require('./common/coachmark/coachmarkDefaultTemplate.html')); // eslint-disable-line global-require
        $templateCache.put('app/common/httpError/httpError.html', require('./common/httpError/httpError.html')); // eslint-disable-line global-require
        $templateCache.put('app/common/controls/spinnerButton/spinnerButton.html', require('./common/controls/spinnerButton/spinnerButton.html')); // eslint-disable-line global-require
        $templateCache.put('app/common/controls/spinnerLink/spinnerLink.html', require('./common/controls/spinnerLink/spinnerLink.html')); // eslint-disable-line global-require
        $templateCache.put('app/common/topNav/sso.html', require('./common/topNav/sso.html'));// eslint-disable-line global-require
        $templateCache.put('app/accounts/user/paceCredential/popoverTemplates/paceParticipant.html', require('./accounts/user/paceCredential/popoverTemplates/paceParticipant.html')); // eslint-disable-line global-require
        $templateCache.put('app/accounts/user/paceCredential/popoverTemplates/certifiedPaceProfessional.html', require('./accounts/user/paceCredential/popoverTemplates/certifiedPaceProfessional.html')); // eslint-disable-line global-require
        $templateCache.put('app/accounts/user/paceCredential/modals/ParticipantVsCertifiedProfessionalComparison.html', require('./accounts/user/paceCredential/modals/ParticipantVsCertifiedProfessionalComparison.html')); // eslint-disable-line global-require
    });


/*eslint-disable */

let HEROProPermissions = [];


function getAuthToken() {
  const authToken = localStorage.getItem('ls.authorizationData');

  if (authToken !== null) {
    return JSON.parse(authToken).access_token;
  }

  // If the auth token is not available in local storage, try to get it from the cookie
  return getCookie('copo_token');
}

function getCookie(cname) {
    let name = `${cname}=`;
    let decodedCookie = decodeURIComponent(document.cookie);
    let cookieArray = decodedCookie.split(';');

    for(let cookie of cookieArray) {
        while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) === 0) {
            return cookie.substring(name.length, cookie.length);
        }
    }

    return '';
}

function getPermissions() {
  const initInjector = angular.injector(['ng']);
  const $http = initInjector.get('$http');

  const applicationSource = '35'; // Hardcoded to HEROPro Web value
  let heroProApi = process.env.NODE_ENV === 'development' ? 'https://proapi.dev-foahomeimprovement.com/' :  '#{Urls.API.HEROPro}/';

  const authToken = getAuthToken();

  const httpConfig = {
    headers: {
      common: {
        'X-RACtx': `sa=${applicationSource}`,
        'X-Requested-With': 'XMLHttpRequest',
      },
      Authorization: `Bearer ${authToken}`,
    },
    withCredentials: true,
  };

  return $http.get(`${heroProApi}User/Permissions`, httpConfig).then((response) => {
    HEROProPermissions = (response.data.Permissions !== undefined) ? response.data.Permissions : [];
  }, (errorResponse) => {
    console.log('errorResponse: ', errorResponse);
  });
}


function bootstrapApplication() {
  angular.element(document).ready(() => {
    angular.bootstrap(document, ['HeroPRO']);
  });
}

if (/PhantomJS/.test(window.navigator.userAgent) || window.jasmine) {
  bootstrapApplication();
} else {
  // START HERE: Wait until permissions are retrived before bootstraping the Angular app
  getPermissions().then(bootstrapApplication);
}

// This is executed after the application is bootstrapped
HEROPro.run((PermissionsFactory) => { //
  PermissionsFactory.setPermissions(HEROProPermissions);
});

/* eslint-enable */



// WEBPACK FOOTER //
// ./src/app/index.js